import { render, staticRenderFns } from "./PostType.vue?vue&type=template&id=2633d8b0&"
import script from "./PostType.vue?vue&type=script&lang=js&"
export * from "./PostType.vue?vue&type=script&lang=js&"
import style0 from "./PostType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports